<div class="detail">
  <h1>Vizuální diagnostika</h1>
  <fieldset>
    <h2 (click)="onToggleDistrictStatus()"><span style="display:inline-block;width:20px;"><i class="fa" [ngClass]="{'fa-caret-down' : districtStatusVisible, 'fa-caret-right' : !districtStatusVisible}"></i></span> Stav dat vizuální diagnostiky</h2>
    <div *ngIf="districtStatusVisible" class="bordered">
      <div [loading]="!districtStatusesGrouped">
        <div class="empty-info" *ngIf="districtStatusesGrouped && !districtStatusesGrouped?.length">Nenalezeny žádné výsledky</div>
        <table *ngIf="districtStatusesGrouped && districtStatusesGrouped?.length">
          <thead><tr>
            <th rowspan="2">Okres</th>
            <th colspan="3" class="bordered-bottom">Silnice II. třídy</th>
            <th colspan="3" class="bordered-bottom">Silnice III. třídy</th>
          </tr>
          <tr>
            <th>Datum diagnostiky</th>
            <th>Rozsah [<span class="unit">km</span>]</th>
            <th>Rozsah zapracovaných oprav [<span class="unit">km</span>]</th>
            <th>Datum diagnostiky</th>
            <th>Rozsah [<span class="unit">km</span>]</th>
            <th>Rozsah zapracovaných oprav [<span class="unit">km</span>]</th>
          </tr></thead>
          <tbody>
          <tr *ngFor="let district of districtStatusesGrouped">
            <td>{{district.districtName}}</td>
            <td>{{district.diagnosticsDate3|date:'MM/yyyy'}}</td>
            <td class="number">{{district.diagnosticsLength3|number}}</td>
            <td class="number">{{district.repairsLength3|number}}</td>
            <td>{{district.diagnosticsDate4|date:'MM/yyyy'}}</td>
            <td class="number">{{district.diagnosticsLength4|number}}</td>
            <td class="number">{{district.repairsLength4|number}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </fieldset>

</div>
<div class="list">
  <filter [list]="summaryList" (onChanged)="onFilterChanged()">
    <gmt-select *ngIf="summaryList" multiselect="true" [data]="summaryList.filter.filters.districtId" [globalFilterConfig]="globalFilter" field="values" [attributes]="{geometry: {load: false}}" [filter]="filterDistrict" resource="districts/list" selectTitle="Okres"></gmt-select>
    <gmt-select *ngIf="summaryList" multiselect="true" [data]="summaryList.filter.filters.roadMasterId" [globalFilterConfig]="globalFilter" field="values" [attributes]="{geometry: {load: false}}" [filter]="filterRoadMaster" resource="road-masters/list" selectTitle="Cestmistrovství"></gmt-select>
    <gmt-select *ngIf="summaryList" multiselect="true" [data]="summaryList.filter.filters.roadClassId" [globalFilterConfig]="globalFilter" field="values" [attributes]="{geometry: {load: false}}" [filter]="filterRoadClass" resource="road-classes/list" selectTitle="Třída silnice" [itemPipe]="roadClassNamePipe"></gmt-select>
    <gmt-select *ngIf="summaryList" multiselect="true" [data]="summaryList.filter.filters.roadId" [globalFilterConfig]="globalFilter" field="values" [attributes]="{geometry: {load: false}}" [filter]="filterRoad" resource="roads/list" selectTitle="Silnice"></gmt-select>
  </filter>

  <fieldset>
    <h2>Přehled 100m úseků</h2>

    <div [loading]="!summaryList || summaryList.loading">
      <div class="flexbox-container" *ngIf="summaryList.list" >
        <div style="width:25%; min-width: 450px;">
          <gmt-pie-chart [data]="summaryChart" [title]="[summaryChartLabel.totalCount, summaryChartLabel.totalPriceFormated]" [subTitle]="['počet úseků', 'cena [Kč]']" subSubTitle=""></gmt-pie-chart>
        </div>
        <div class="flex-rest">
          <div>
            <table class="bordered">
              <thead><tr>
                <th>Klasifikační stupeň</th>
                <th>Počet úseků</th>
                <th>Počet poruch</th>
                <th>Cena</th>
              </tr></thead>
              <tbody>
                <tr *ngFor="let summary of summaryList.list; index as i">
                  <td><img src="img/map/fill-{{i ? colors[i] : 'ffffff-border-1-solid-222222'}}.svg"> {{summary.index ? 'Klas. stupeň ' + summary.index : 'Neklasifikováno'}}</td>
                  <td class="number">{{summary.sectionCount | number}}</td>
                  <td class="number">{{summary.faultCount | number}}</td>
                  <td class="number">{{summary.price | number | price}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </fieldset>

  <div class="bordered" [loading]="!list || list.loading">
    <div class="empty-info" *ngIf="list && !list.loading && list.list && !list.itemCount">Nenalezeny žádné výsledky</div>
    <table *ngIf="list && list.list && list.itemCount">
      <thead><tr>
        <th>Okres</th>
        <th>Cestmistrovsví</th>
        <th>Silnice</th>
        <th>Délka silnice [<span class="unit">km</span>]</th>
        <th>Počet úseků</th>
        <th>Počet poruch</th>
        <th>Cena oprav</th>
      </tr></thead>
      <tbody>
      <tr *ngFor="let row of list.list; index as i">
        <td>{{row.district}}</td>
        <td>{{row.roadMaster}}</td>
        <td>{{row.road}}</td>
        <td class="number">{{row.roadLength | number}}</td>
        <td class="number">{{row.sectionCount | number}}</td>
        <td class="number">{{row.faultCount | number}}</td>
        <td class="number">{{row.price | number | price }}</td>
      </tr>
      </tbody>
    </table>
  </div>

  <help [helpId]="helpIds.VM_PANEL_DIAGNOSTICS_OVERVIEW" class="cm-help-page"></help>
</div>
